import { auth } from '@/firebase'
import {
  ImportantNotice,
  FSImportantNotice
} from '@/helpers/fs/importantNotice'
import { defineStore } from 'pinia'
import { useActivityStatusStore } from './userActivityStatusStore'

type StoredImportantNotice = FSImportantNotice & { id: string }

/**
 * ユーザーの登録日時（ミリ秒）。取得できない場合は null。
 */
const signedUpAtMillis = (): number | null => {
  const creationTime = auth.currentUser?.metadata.creationTime
  return creationTime ? Date.parse(creationTime) : null
}

type State = {
  notices: StoredImportantNotice[]
}

export const useImportantNoticeStore = defineStore('importantNotice', {
  state: (): State => ({
    notices: []
  }),
  actions: {
    async setup() {
      this.sync('notices', ImportantNotice.publishedQuery())
    }
  },
  getters: {
    /**
     * 未開封のお知らせ（新しい順）
     * 登録より前に公開されたお知らせはそのユーザーにとって新しい情報ではなく、
     * 登録直後にモーダルが出てしまうため表示しない。
     */
    visibleNotices(state): StoredImportantNotice[] {
      const activityStatus = useActivityStatusStore()
      const closedIds = new Set(
        activityStatus.data?.closedImportantNoticeIds ?? []
      )
      const signedUpAt = signedUpAtMillis()
      return state.notices.filter(
        (notice) =>
          !closedIds.has(notice.id) &&
          (signedUpAt === null || notice.publishedAt.toMillis() > signedUpAt)
      )
    }
  }
})
